import clsx from 'clsx';
import i18n from '../../../common/i18n';
import { SvgIcon } from '../../../icons/SvgIcon';
import * as React from 'react';
import './AutocompleteFilterInput.less';
import { AutocompleteRenderInputParams } from '@material-ui/lab';

export const AutocompleteFilterInput = (params: AutocompleteRenderInputParams) => (
    <div className={'nui-autocomplete-input-root'} ref={params.InputProps.ref}>
        <div className={clsx('p-rel flex items-center')}>
            <input
                {...params.inputProps}
                type="search"
                autoFocus={true}
                autoComplete="off"
                placeholder={i18n('nui.filter.search')}
                className={clsx('nui-search-input py-5 fs-14 full-width br-radius-xs')}
            />
            <SvgIcon className={clsx('nui-search-icon mr-10 ml-10 p-abs')} imgId="search" sizeX="20" sizeY="20" />
        </div>
    </div>
);
